class HowItWorks extends HTMLElement {
  connectedCallback() {
    this.panelsEl = this.querySelector('.how-it-works__panels');
    this.panels = [...this.querySelectorAll('.how-it-works__panel')];
    this.sidebarInfos = [...this.querySelectorAll('.how-it-works__info')];
    this.navDots = [...this.querySelectorAll('.how-it-works__nav-dot')];

    this.currentStep = 1;
    this.currentOptions = {};
    this.userInteracted = {};
    this.cycleTimers = {};
    this.autoCycleInterval = parseInt(this.dataset.autoCycle) || 3000;
    this.desktopMQ = window.matchMedia('(min-width: 990px)');

    this.setupOptionClicks();
    this.setupNavDots();
    this.setupDesktopObserver();
    this.startAllAutoCycles();
  }

  setupDesktopObserver() {
    if (!this.panels.length) return;

    this.panelObserver = new IntersectionObserver(
      (entries) => {
        if (!this.desktopMQ.matches) return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const step = parseInt(entry.target.dataset.panel);
            this.setActiveStep(step);
          }
        });
      },
      { threshold: 0.5 }
    );

    this.panels.forEach((panel) => this.panelObserver.observe(panel));
  }

  setupNavDots() {
    this.navDots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const step = parseInt(dot.dataset.gotoStep);
        const panel = this.querySelector(
          `.how-it-works__panel[data-panel="${step}"]`
        );
        if (panel) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        this.setActiveStep(step);
      });
    });
  }

  setupOptionClicks() {
    this.querySelectorAll('.how-it-works__option').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.step);
        const option = parseInt(btn.dataset.option);
        this.userInteracted[step] = true;
        this.setActiveOption(step, option);
      });
    });
  }

  setActiveStep(step) {
    if (this.currentStep === step) return;
    this.currentStep = step;

    this.sidebarInfos.forEach((el) => {
      el.classList.toggle('is-active', parseInt(el.dataset.step) === step);
    });

    this.navDots.forEach((el) => {
      el.classList.toggle(
        'is-active',
        parseInt(el.dataset.gotoStep) === step
      );
    });
  }

  setActiveOption(step, option) {
    // Update option buttons for this step (all instances: sidebar + panel)
    this.querySelectorAll(
      `.how-it-works__option[data-step="${step}"]`
    ).forEach((btn) => {
      btn.classList.toggle(
        'is-active',
        parseInt(btn.dataset.option) === option
      );
    });

    // Update images
    this.querySelectorAll(
      `.how-it-works__images[data-step="${step}"] .how-it-works__image`
    ).forEach((img) => {
      img.classList.toggle(
        'is-active',
        parseInt(img.dataset.option) === option
      );
    });

    this.currentOptions[step] = option;
  }

  startAllAutoCycles() {
    this.panels.forEach((panel) => {
      const step = parseInt(panel.dataset.panel);
      const options = this.querySelectorAll(
        `.how-it-works__option[data-step="${step}"]`
      );
      if (options.length <= 1) return;

      this.currentOptions[step] = 1;
      this.cycleTimers[step] = setInterval(() => {
        if (this.userInteracted[step]) {
          clearInterval(this.cycleTimers[step]);
          return;
        }
        const optionCount =
          this.querySelectorAll(
            `.how-it-works__images[data-step="${step}"] .how-it-works__image`
          ).length || options.length;
        let next = (this.currentOptions[step] || 1) + 1;
        if (next > optionCount) next = 1;
        this.setActiveOption(step, next);
      }, this.autoCycleInterval);
    });
  }

  disconnectedCallback() {
    Object.values(this.cycleTimers).forEach((timer) => clearInterval(timer));
    if (this.panelObserver) this.panelObserver.disconnect();
  }
}

customElements.define('how-it-works', HowItWorks);
